import { useBoolean } from 'ahooks'
import { Space, Typography } from 'antd'
import { useTheme } from 'antd-style'

import { UserEntity } from '@eastcoal/api/auth/interface'

import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { BindPhone } from '@eastcoal/auth/components/BindPhone'
import { useAuthStore, useAuthStoreApi } from '@eastcoal/auth/hooks/useStore'

export const Phone = () => {
  const { user } = useAuthStore(state => pick(state, ['user']))
  const { setState } = useAuthStoreApi()

  const [open, openActions] = useBoolean(false)
  const { message } = useFeedback()

  const handleBindSuccess = (res: UserEntity) => {
    message.success('手机更换成功')
    setState({ user: res })
  }

  const theme = useTheme()

  return (
    <Space size='small'>
      <span>手机号:</span>
      <span>
        {user.phone}&nbsp;
        <Typography.Link
          style={{
            fontSize: theme.fontSizeSM
          }}
          onClick={openActions.setTrue}
        >
          换绑
        </Typography.Link>
        <BindPhone
          open={open}
          onOpenChange={openActions.toggle}
          onSuccess={handleBindSuccess}
        />
      </span>
    </Space>
  )
}
